export enum ResilienceType {
    NO_RESILIENCE="No Resilience",
    NR="N+R",
    ACTIVE="2(N+R) Active/Active",
    STANDBY="2(N+R) Active/Standby"
}